import { createContext } from "react";
import { ILoaderContext } from "../../types/ILoaderContext";

export const LoaderContext = createContext<ILoaderContext | null>(null);